import { DialogContent } from '@mui/material';
import { isEmpty } from 'lodash-es';
import React, { useState } from 'react';
import { IBooleanQueryBuilderDTO, IJob } from 'wisestep-api';

import CustomiseBooleanQuery from './CustomiseBooleanQuery';
import GenerateBooleanQuery from './GenerateBooleanQuery';
interface booleanQueryProps {
  closeDialog: () => void;
  job: IJob;
}
const BooleanQuery = ({ closeDialog, job }: booleanQueryProps) => {
  const defaultBooleanQuery = {
    mode: 'jobDescription',
    jobTitle: job.title,
    requiredSkills: job.skills,
    jobDescription: job.description,
    jobId: job.id,
    queryTypes: { open: true, focused: true, comprehensive: true },
    queryResponse: { open: 'true', focused: 'true', comprehensive: 'true' },
  };
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState<IBooleanQueryBuilderDTO>(defaultBooleanQuery);

  const handleClickOpen = () => setOpen(true);

  const handleClose = (customQuery: IBooleanQueryBuilderDTO | null) => {
    if (!isEmpty(customQuery)) {
      const updatedQuery = { ...query };
      updatedQuery.jobDescription = customQuery?.jobDescription;
      updatedQuery.jobTitle = customQuery?.jobTitle ?? job.title;
      updatedQuery.requiredSkills = customQuery?.requiredSkills;
      setQuery(updatedQuery);
    } else {
      setQuery(defaultBooleanQuery);
    }
    setOpen(false);
  };
  return !open ? (
    <DialogContent>
      <GenerateBooleanQuery
        closeDialog={closeDialog}
        handleClickOpen={handleClickOpen}
        job={job}
        defaultQuery={query}
      />
    </DialogContent>
  ) : (
    <CustomiseBooleanQuery
      closeDialog={closeDialog}
      handleClose={(customQuery) => handleClose(customQuery)}
      job={job}
    />
  );
};

export default BooleanQuery;
